"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = Address;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
// Packages

// Styles
const Container = _styledComponents.default.div.withConfig({
  displayName: "address__Container",
  componentId: "sc-wk35rx-0"
})(["p{margin:0;}"]);

// Main Component
function Address({
  cityBreak,
  cityComma,
  professional,
  stateBreak,
  streetBreak,
  streetComma,
  suiteBreak,
  suiteComma
}) {
  const professionalAddress = {
    ...professional
  };
  professionalAddress.street = (professional === null || professional === void 0 ? void 0 : professional.street) || (professional === null || professional === void 0 ? void 0 : professional.streetAddress);
  const corporateAddress = {
    city: `Virginia Beach`,
    state: `VA`,
    street: `600 Lynnhaven Parkway`,
    suite: `Suite 100`,
    zip: `23452`
  };
  let address = professional ? professionalAddress : corporateAddress;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, {
    className: "address"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "street"
  }, address.street, streetComma && /*#__PURE__*/_react.default.createElement("span", {
    className: "comma"
  }, ",")), streetBreak && /*#__PURE__*/_react.default.createElement("br", null), address.suite && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "suite"
  }, " ", address.suite, suiteComma && /*#__PURE__*/_react.default.createElement("span", {
    className: "comma"
  }, ",")), suiteBreak && /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement("span", {
    className: "city"
  }, " ", address.city, cityComma && /*#__PURE__*/_react.default.createElement("span", {
    className: "comma"
  }, ",")), cityBreak && /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: "state"
  }, " ", address.state, " "), stateBreak && /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: "zip"
  }, " ", address.zip)));
}

// Prop Types
Address.propTypes = {
  /**
   * Properties of professional used to show address info (street address, suite, city, state, zip)
   */
  professional: _propTypes.default.object,
  /**
   * Should there be a break after the city? (<br />)
   */
  cityBreak: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * Should there be a comma after the city? (Virginia Beach,)
   */
  cityComma: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * Should there be a break after the state? (<br />)
   */
  stateBreak: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * Should there be a break after the street? (<br />)
   */
  streetBreak: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * Should there be a comma after the street? (127 Street,)
   */
  streetComma: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * Should there be a break after the suite? (<br />)
   */
  suiteBreak: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * Should there be a comma after the suite? (Suite 100,)
   */
  suiteComma: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
};
Address.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Address",
  "props": {
    "professional": {
      "description": "Properties of professional used to show address info (street address, suite, city, state, zip)",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "cityBreak": {
      "description": "Should there be a break after the city? (<br />)",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "cityComma": {
      "description": "Should there be a comma after the city? (Virginia Beach,)",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "stateBreak": {
      "description": "Should there be a break after the state? (<br />)",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "streetBreak": {
      "description": "Should there be a break after the street? (<br />)",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "streetComma": {
      "description": "Should there be a comma after the street? (127 Street,)",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "suiteBreak": {
      "description": "Should there be a break after the suite? (<br />)",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "suiteComma": {
      "description": "Should there be a comma after the suite? (Suite 100,)",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }]
      },
      "required": false
    }
  }
};